import browserHistory from 'shared/history';
import {getCollege} from 'shared/actions/college';
import {getStudent} from 'shared/actions/student';
import {receiveCollegeDataForStudent} from 'shared/actions/college-data-for-student';
import {startLoading, stopLoading} from 'shared/actions/loading';
import {flashMessage, errorMessage} from 'shared/actions/notifications';
import req from 'shared/req';

export const LOADING_IDENTIFIERS = {
  initial: 'studentProfileInitialInfo',
  portfolio: 'studentProfilePortfolio',
  earnings: 'studentProfileEarnings',
};

const STUDENT_FIELDS = [
  'firstName',
  'lastName',
  'photo',
  'email',
  'highSchoolInfo',
  'communityCollegeInfo',
  'currentInstitution',
  'educationPhase',
  'highSchoolFrlPercentage',
  'lunchPlan',
  'isFirstGen',
  'totalCredits',
  'addressLine1',
  'addressLine2',
  'city',
  'subdivision',
  'postalCode',
  'birthday',
  'bio',
  'mobile',
  'fafsaSubmission',
  'academicInterests',
  'gender',
  'sex',
  'ethnicity',
  'lastActive',
  'createdAt',
  'customGenderIdentity',
  'connectionInfo',
  'notificationSettings',
  'cannotMessageReason',
].join(',');

const COLLEGE_FIELDS = [
  'submissionStatus',
  'partnerScholarships',
  'divisor',
  'amount',
  'userInState',
  'earningRelationship',
  'applicationStatus',
  'isFollowing',
].join(',');

export const getCollegeDataForStudent = (collegeListingId, userId) => (dispatch) =>
  getCollege(collegeListingId, COLLEGE_FIELDS, {userId}).then((collegeData) =>
    dispatch(receiveCollegeDataForStudent(collegeData))
  );

export const printPortfolio = () => () => {
  browserHistory.push(
    window.location.pathname.replace(/\/(details|earnings)$/, '').concat('/print')
  );
};

export const resetLoading = () => (dispatch) => {
  dispatch(startLoading(LOADING_IDENTIFIERS.initial));
  dispatch(startLoading(LOADING_IDENTIFIERS.portfolio));
  dispatch(startLoading(LOADING_IDENTIFIERS.earnings));
};

// fires off requests for basic info, portfolio info, and earnings info simultaneously
// as responses come back it toggles the loading state for that info
export const loadData =
  ({studentCode, collegeListingId}) =>
  (dispatch) => {
    dispatch(startLoading(LOADING_IDENTIFIERS.initial));
    dispatch(getStudent(studentCode, STUDENT_FIELDS))
      .then(() => {
        dispatch(stopLoading(LOADING_IDENTIFIERS.initial));
      })
      .catch(() => {
        location.href = '/404';
      });
    dispatch(startLoading(LOADING_IDENTIFIERS.portfolio));
    dispatch(getStudent(studentCode, 'portfolio')).then(() => {
      dispatch(stopLoading(LOADING_IDENTIFIERS.portfolio));
    });

    dispatch(startLoading(LOADING_IDENTIFIERS.earnings));
    let promise;

    if (collegeListingId) {
      promise = dispatch(getCollegeDataForStudent(collegeListingId, studentCode));
    } else {
      promise = dispatch(getStudent(studentCode, 'earnings'));
    }

    promise.then(() => {
      dispatch(stopLoading(LOADING_IDENTIFIERS.earnings));
    });
  };

export const awardSpotScholarship = (values) => (dispatch) =>
  req({
    url: '/college-portal/confirm-spot-scholarship',
    method: 'post',
    data: values,
  })
    .then((collegeData) => {
      const {
        location: {pathname},
      } = window;
      dispatch(receiveCollegeDataForStudent(collegeData));
      browserHistory.push({pathname: pathname.split('/spot-award')[0]});
      dispatch(flashMessage('Scholarship successfully awarded.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });
